// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderTotalDisplaySharedStyles } from "@rpsc/App/SharedStyles/MyAccountPages/Details/OrderTotalDisplaySharedStyles";
import { xTitledSectionStyles } from "@rpsc/App/Widgets/XTitledSection/XTitledSection";
import { color, linkArrowStyle, mergeWithCss, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

xTitledSectionStyles.wrapper = {
    css: css`
        display: flex;
        flex: 1;
        flex-direction: column;
        gap: 16px;
        margin: ${({ margin }: any) => margin};
    `,
};

xTitledSectionStyles.leftSide = {
    css: css`
        display: flex;
        align-items: center;
        flex: 1;
        ${xScreen("lt", "sm")} {
            width: 100%;
        }
    `,
};

xTitledSectionStyles.title = {
    css: css`
        margin-bottom: 0;
        display: flex;
    `,
};

xTitledSectionStyles.link = {
    ...mergeWithCss(linkArrowStyle, {
        typographyProps: {
            size: 16,
            css: css`
                line-height: 22px;
            `
        },
        css: css`
            ${xScreen("lte", "md")} {
                align-self: center;
            }
            ${xScreen("lte", "sm")} {
                align-self: flex-start;
            }
        `,
    }),
};

xTitledSectionStyles.container = {
    css: css`
        display: flex;
        align-items: center;
        ${({ showBorder }: any) =>
            showBorder &&
            css`
                padding-bottom: 8px;
                border-bottom: 1px solid ${color("common.border")};
            `}
        ${xScreen("lte", "sm")} {
            flex-direction: column;
            gap: 16px;
            align-items: flex-start;
        }
    `,
};

xTitledSectionStyles.styledHr = {
    ...orderTotalDisplaySharedStyles.styledHr,
};
